import { render, staticRenderFns } from "./PreOrder.vue?vue&type=template&id=4fb4574a&scoped=true"
import script from "./PreOrder.vue?vue&type=script&lang=js"
export * from "./PreOrder.vue?vue&type=script&lang=js"
import style0 from "./PreOrder.vue?vue&type=style&index=0&id=4fb4574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb4574a",
  null
  
)

export default component.exports